/**
 * Chip and tooltip formatters for `selectFrom` fields, whose editor emits
 * `JSON.stringify(names)`. They live here rather than on
 * `SelectFromMatcher.options.chipFormatter` because that default can't resolve a
 * name to a display name without the field's own `selectionOptions` — so every
 * consumer passes them in and overrides the default per field.
 */
import type { SelectionOption } from '@cdw-ae/filter-bar-interfaces';

export const selectFromChipFormatter = (
  value: string,
  selectionOptions: SelectionOption[]
): string => {
  try {
    const selectedNames: string[] = JSON.parse(value);

    const displayNames = selectedNames.map(
      (name) =>
        selectionOptions.find((opt) => opt.name === name)?.displayName ?? name
    );

    if (displayNames.length === 0) return '';
    if (displayNames.length === 1) return `: ${displayNames[0]}`;
    if (displayNames.length === 2)
      return `: ${displayNames[0]} OR ${displayNames[1]}`;
    return `: ${displayNames[0]}, ${displayNames[1]} +${displayNames.length - 2} more`;
  } catch {
    return value;
  }
};

export const selectFromToolTipFormatter = (
  value: string,
  selectionOptions: SelectionOption[]
): string => {
  try {
    const selectedNames: string[] = JSON.parse(value);

    const displayNames = selectedNames.map(
      (name) =>
        selectionOptions.find((opt) => opt.name === name)?.displayName ?? name
    );

    return displayNames.join(', ');
  } catch {
    return value;
  }
};
